export default __webpack_public_path__ + "8ec268bd33dad7a8bacba511e99e106c.svg";